const userSurveyTypes = {
    SOURCING: 'sourcing',
    MOTIVATION: 'motivation',
    REASON: 'reason',
};

export default userSurveyTypes;
